//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function loadProductsService() {
  try {
    const response = await api.get("/produtos");
    return response;
  } catch (error) {
    toast.error("Erro ao carregar produtos!");
    return false;
  }
}